import { useParams, Navigate } from 'react-router-dom';
import DocsLayout from './DocsLayout';
import { allDocPages, defaultDocSlug } from './docsNav';

export default function DocsPage() {
  const { slug } = useParams();

  // Validate that the slug exists in the nav
  const pageExists = allDocPages.some((p) => p.slug === slug);

  if (!pageExists) {
    return <Navigate to={`/docs/${defaultDocSlug}`} replace />;
  }

  return <DocsLayout slug={slug} />;
}
